import React from "react";
import {useLanguage} from "../../../hooks/LanguageContext";
import {Button} from "../../index";
import {useNavigate} from "react-router-dom";

const LocationsOurBranches = () => {
	const { direction } = useLanguage();
	const navigate = useNavigate();
	const handleOnSubmit = (event) => {
		event.preventDefault();
		navigate('/branches');
	};

	// Dynamic text based on direction
	const headingText = direction === "rtl" ? "اكتشف أقرب فرع إليك..." : "Find the nearest branch to you...";
	const subText =
		direction === "rtl"
			? "أدخل مدينتك أو محافظتك وسنعرض لك أقرب فرع لخدمتك."
			: "Enter your city or governorate, and we will show you the nearest branch to serve you.";
	const placeholderText = direction === "rtl" ? "أدخل مدينتك او محافظتك" : "Enter your city or governorate";
	const buttonText = direction === "rtl" ? "ابحث عن فرعنا" : "Find Our Branch";

	return (
		<div className={`md:w-[1102px] w-full flex flex-col items-start gap-4 md:gap-8 z-[2] ${direction === "rtl" ? "text-right" : "text-left"}`}>
			<h3 className="headline-3-ar text-grayscale-600">{headingText}</h3>

			<div className={`flex items-baseline ${direction === "rtl" ? "justify-start" : "justify-end"} gap-[13px]`}>
				<span className="md:w-[12px] md:h-[12px] w-[10px] h-[10px] bg-primary-700 rounded-full"></span>
				<span className="text-grayscale-500 font-bold md:text-xl lg:text-2xl">{subText}</span>
			</div>

			<form
				onSubmit={handleOnSubmit}
				className="md:w-[650px] w-full md:h-[95px] h-14 flex justify-between items-center py-[20px] md:px-[30px] bg-bg-light shadow-custom-shadow rounded-md"
			>
				<div className={`md:w-[600px] w-full md:h-[50px] h-14 flex ${direction === "rtl" ? "flex-row" : "flex-row-reverse"} items-center`}>
					<input
						type="text"
						className="bg-bg-light text-primary-600 flex-1 px-3"
						placeholder={placeholderText}
					/>
					<Button  className="md:rounded-[13px] rounded-lg">
						{buttonText}
					</Button>
				</div>
			</form>
		</div>
	);
};

export default LocationsOurBranches;
